<template>
    <div>
        <AGISHeader title="Sewerage System" :subMenuItems="subMenuItems" :helpVisible="false"/>
        <AGISRouteView :subMenuItems="subMenuItems" ref="agis-route-view"/>
    </div>
</template>

<script>
import AGISHeader from '@/components/ui-components/AGISHeader';
import AGISRouteView from '@/components/ui-components/AGISRouteView';

export default {
  name: 'ss-layout',
  components: {
      AGISHeader,
      AGISRouteView,
  },
  created: function () {
  },
  data:function(){
      return {
        showSidePanel: true,
        subMenuItems: [
            {
                routeName: 'Home',
                title: ' Home'
            },
            {
                routeName: 'Sewer Water Welcome',
                title: ' Welcome'
            },
            {
                routeName: 'Sewer Asset',
                title: ' Asset'
            },
            {
                routeName: 'Sewer Relining',
                title: ' Relining'
            },
            {
                routeName: 'Sewer CCTV',
                title: ' CCTV'
            },
            {
                routeName: 'Sewer Water Maintenance',
                title: ' Maintenance'
            },
            {
                routeName: 'Sewer Simulation',
                title: ' Simulation'
            },
            {
                routeName: 'Sewer AAMS Asset',
                title: ' AAMS Asset'
            },
          ]
      }
  },
  methods: {
  }
}

</script>

<style>

.esri-ui-corner .esri-legend{
    font-size:0.7em;
    min-width:10em;
    padding:0;
}
.esri-legend__service{
    padding:0;
}
.esri-legend__service-label{
    margin:0;
}
.esri-legend__layer-table{
    margin-bottom:0;
    text-align: left;
}

.esri-legend__layer-cell{
    padding:0;
    min-width:auto;
}
</style>



// WEBPACK FOOTER //
// src/components/sewer-area/Layout.vue